import React, { useEffect } from 'react'
// eslint-disable-next-line no-unused-vars
import { __ } from '@wordpress/i18n'
import { Link, Outlet, useLocation } from 'react-router-dom'

// store
import { useStoreValue, storeSet } from '../../store'

//components
import Logout from './components/Logout'
import Projects from './components/ProjectsButton'
import SetupButton from './components/SetupButton'
import DashboardButton from './components/DashboardButton'
import ElaborationsButton from './components/ElaborationsButton'

import logo from '../../assets/logo_scan.png'


const DefaultLayout = ({ children }) => {
  const isError404 = useStoreValue('isError404')
  const location = useLocation()

  useEffect(() => {
    storeSet('isError404', false)
  }, [location])

  return (
    <div className="wrapper" style={{ width: '100%' }}>
      <div className="bg-primary topbar">
        <Link to={'/dashboard/home'}><img src={logo} alt='logo'/></Link>
      </div>
      <div className="inner" >
  
          <div className="sidebar">
          <div className='sidebar__Wrapper'>
            <DashboardButton />
            <Projects/>
            <ElaborationsButton/>
            <SetupButton/>
          </div>
          
          <Logout />
        </div>
        <main>
          {isError404 ? <p>Error 404</p> : children}
          <Outlet />
        </main>
        </div>
        

      <footer className="bg-primary">
        <p>© {new Date().getFullYear()} SCAN360. Tutti i diritti riservati</p>
      </footer>
    </div>
  )
}

export default DefaultLayout
